module.exports = __webpack_public_path__ + "img/title-banner.2d6bc58b.webp";